import type { DingTalkSdk, WxWorkSdk, LarkSdk, WeChatSdk } from '../integration-env';
import type H5JsApi from '../core/h5-jsapi';
import { FunctionKeys } from './utils';

// 以枚举形式维护sdk类型，并向业务侧暴露
export enum SdkType {
    // 浏览器环境
    Browser = 'browser',
    // 微信环境
    WeChat = 'wechat',
    // 企微环境
    WxWork = 'wxwork',
    // 钉钉环境
    DingTalk = 'dingtalk',
    // 飞书环境
    Lark = 'lark',
    // jodoo App环境
    Jodoo = 'jodoo',
    // 简道云 App环境
    Jdy = 'jdy'
}

export { SdkError } from './sdk-error';

/**
 * SDK API 集合，包含业务侧需要用到的 SDK API，也包含那些仅在 XxxSdk 中自用的 API，
 * 这些 API 不在 JsSdkBase 中，但也需要加上 sdkLog
 */
export type SdkApi =
    | FunctionKeys<DingTalkSdk>
    | FunctionKeys<LarkSdk>
    | FunctionKeys<WxWorkSdk>
    | FunctionKeys<WeChatSdk>
    | FunctionKeys<H5JsApi>;

/**
 * 可用SDK功能
 * @see g-6233589787
 */
export enum SDKFunction {
    SetHeaderActions = 'setHeaderActions',
    ClearHeaderActions = 'clearHeaderActions',
    AddToDesktop = 'addToDesktop',
    ChooseImage = 'chooseImage',
    DownloadLink = 'downloadLink',
    GoToAboutApp = 'goToAboutApp',
    GoToCreateCorp = 'goToCreateCorp'
}

/**
 * 扫码类型
 */
export enum ScanType {
    // 条形码
    BarCode = 'barCode',
    // 二维码
    QrCode = 'qrCode',
    // 全部
    All = 'all'
}

// 返回数据格式
export interface SdkResult {
    type: SdkType;
    code: Symbol;
}
